module.exports = __webpack_public_path__ + "static/full-jo-fine-art.bf4d14e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/full-jo-fine-art.gif
// module id = 225
// module chunks = 35783957827783 213720915766396